/**
 * Artifact-key extension matchers for exploratory-run evidence (screenshots/video), shared by
 * `ExplorationReport` (the execution-log renderer) and the chat digest/card in `run-actions/` so
 * both surfaces recognize the same evidence. Kept in a non-React module: `run-actions/runDigest.ts`
 * sits on the chat-handoff path, and importing a React component file from there would pull UI code
 * (and its transitive deps) into a path that has no business rendering anything.
 */
export const IMAGE_RE = /\.(png|jpe?g|webp|gif)$/i;
export const VIDEO_RE = /\.(webm|mp4)$/i;
